import { ButtonBase, Typography } from "@mui/material"
import { Link, useLocation } from "@tanstack/react-router"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

interface ApprovalBucketTabProps {
  label: string
  path: string
  count: number
  disabled: boolean
  "data-testid": string
}

export const ApprovalBucketTab: FC<ApprovalBucketTabProps> = ({
  label,
  path,
  count,
  disabled,
  "data-testid": testId,
}) => {
  const location = useLocation()
  const isActive = location.pathname.startsWith(path)

  return (
    <ButtonBase
      component={Link}
      to={path}
      disabled={disabled}
      aria-pressed={isActive}
      data-testid={testId}
      className={twMerge(
        "flex flex-col items-start gap-y-2 rounded border border-solid border-gray-400 bg-white p-4 text-left",
        disabled ? "opacity-60" : "hover:border-primary-400",
        isActive && !disabled && "border-2 border-primary"
      )}
    >
      <Typography variant='h4' className='font-medium text-gray-800'>
        {count}
      </Typography>
      <Typography variant='body2' className='text-gray-700'>
        {label}
      </Typography>
    </ButtonBase>
  )
}
